import React from 'react';
// map
import { Marker } from 'react-map-gl';
// components
import { PinMarker } from './PinMarker';
import { SimplePinMarker } from './SimplePinMarker';
export const GeocoderPin = ({ latitude, longitude, draggable, pinMarkerType = 'default', onClick, onDragStart, onDragEnd, onMouseEnter, onMouseLeave, }) => {
    if (!latitude && !longitude) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Marker, { longitude: longitude, latitude: latitude, draggable: draggable, onDragStart: event => {
                if (onDragStart) {
                    onDragStart(event);
                }
            }, onDragEnd: ({ lngLat }) => {
                if (onDragEnd) {
                    onDragEnd(lngLat);
                }
            } }, pinMarkerType === 'simple' ? (React.createElement(SimplePinMarker, { onClick: () => {
                if (onClick) {
                    onClick();
                }
            }, onMouseEnter: () => {
                if (onMouseEnter) {
                    onMouseEnter();
                }
            }, onMouseLeave: () => {
                if (onMouseLeave) {
                    onMouseLeave();
                }
            } })) : (React.createElement(PinMarker, { onClick: () => {
                if (onClick) {
                    onClick();
                }
            }, onMouseEnter: () => {
                if (onMouseEnter) {
                    onMouseEnter();
                }
            }, onMouseLeave: () => {
                if (onMouseLeave) {
                    onMouseLeave();
                }
            } })))));
};
//# sourceMappingURL=GeocoderPin.js.map